import ContextDbIpcRouter, { type ContextDbIpcRouterType } from '@shared/ipc/routers/ContextDbIpc.router'
import { ClipboardRecordType, ClipboardHistoryItem } from '@renderer/chat/types'
import type { PrivacyFilterRuleInput } from '@shared/utils/privacy-filtering.ts'

class ContextDbIpcRenderer extends ContextDbIpcRouter implements ContextDbIpcRouterType {
  async getClipboardHistory({
    limit,
    offset,
    since,
    type,
  }: {
    limit?: number
    offset?: number
    since?: number
    type?: ClipboardRecordType
  }): Promise<ClipboardHistoryItem[]> {
    return this.exec('getClipboardHistory', { limit, offset, since, type })
  }

  async getClipboardCount() {
    return this.exec('getClipboardCount')
  }

  async clearClipboardHistory() {
    return this.exec('clearClipboardHistory')
  }

  async searchClipboardHistory({
    query,
    limit,
    type,
  }: {
    query: string
    limit?: number
    type?: ClipboardRecordType
  }): Promise<ClipboardHistoryItem[]> {
    return this.exec('searchClipboardHistory', { query, limit, type })
  }

  async getScreenshotCount() {
    return this.exec('getScreenshotCount')
  }

  async clearScreenshotHistory() {
    return this.exec('clearScreenshotHistory')
  }

  async deleteClipboardItem(id: number) {
    return this.exec('deleteClipboardItem', id)
  }

  async deleteClipboardByApp(appName: string) {
    return this.exec('deleteClipboardByApp', appName)
  }

  async deleteClipboardByDomain(domain: string) {
    return this.exec('deleteClipboardByDomain', domain)
  }

  async getPrivacyFilters() {
    return this.exec('getPrivacyFilters')
  }

  async addPrivacyRule({ rule, overrideConflict }: { rule: PrivacyFilterRuleInput; overrideConflict?: boolean }) {
    return this.exec('addPrivacyRule', { rule, overrideConflict })
  }

  async updatePrivacyRule({
    id,
    rule,
    overrideConflict,
  }: {
    id: number
    rule: PrivacyFilterRuleInput
    overrideConflict?: boolean
  }) {
    return this.exec('updatePrivacyRule', { id, rule, overrideConflict })
  }

  async removePrivacyRule(id: number) {
    return this.exec('removePrivacyRule', id)
  }

  async resetPrivacyFiltersToDefaults() {
    return this.exec('resetPrivacyFiltersToDefaults')
  }

  async checkPrivacyRuleConflict(rule: PrivacyFilterRuleInput) {
    return this.exec('checkPrivacyRuleConflict', rule)
  }

  async refreshPrivacyDomainMetadata(domain: string) {
    return this.exec('refreshPrivacyDomainMetadata', domain)
  }

  async evaluateFocusedWindowPrivacy(focusedWindow: {
    appName?: string | null
    windowTitle?: string | null
    url?: string | null
  }) {
    return this.exec('evaluateFocusedWindowPrivacy', focusedWindow)
  }
}

export default new ContextDbIpcRenderer()
